import { tr } from './translations'

export const PLANNING_TAB_URL = 'jbp-tab'
export const PLANNING_TAB = 20

export const baseColumns = [
  {
    field: 'PartnerID',
    title: tr.columnPartnerId,
    priority: 1,
  },
  {
    field: 'LocationID',
    title: tr.columnLocationId,
    priority: 2,
  },
  {
    field: 'CommunicationName',
    title: tr.columnPartnerName,
    priority: 3,
  },
  {
    field: 'GeoMarket',
    title: tr.columnMarket,
    priority: 4,
  },
  {
    field: `Country`,
    title: tr.columnCountry,
    priority: 5,
  },
  {
    field: `HierarchyType`,
    title: tr.columnHierarchy,
    priority: 6,
  },
]
